import { Badge, Box, Text } from '@wix/design-system';
import { FeatureGroup as FeatureGroupComp } from '@wix/package-picker-components';
import { Sparkles } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdvancedPlansProductData, FeaturesGroupSection } from '../../../types';
import { FeatureRow } from './FeatureRow';

interface FeatureGroupProps {
  group: FeaturesGroupSection;
  products: AdvancedPlansProductData[];
  isJapanesePackagePicker?: boolean;
}

const getIcon = (iconKey?: string) => {
  switch (iconKey) {
    case 'ai-sparkles-icon':
      return Sparkles;
    default:
      return null;
  }
};

const AI_FEATURE_GROUP_TRANSLATION_KEY =
  'premium-purchase-plan.feature_table.ai_credits_section.title';

const FeatureGroup: React.FC<FeatureGroupProps> = ({
  group,
  products,
  isJapanesePackagePicker = false,
}) => {
  const { t } = useTranslation();
  const Icon = getIcon(group.icon);
  const shouldShowNewBadge =
    group.translationKey === AI_FEATURE_GROUP_TRANSLATION_KEY;

  return (
    <FeatureGroupComp
      header={
        <Box gap='6px' verticalAlign='middle'>
          <Text weight='bold'>{t(group.translationKey)}</Text>
          <Box width='18px' height='18px' align='center' verticalAlign='middle'>
            {Icon && <Icon />}
          </Box>
          {shouldShowNewBadge && (
            <Badge skin='neutralSuccess' size='tiny'>
              {t('features.new_feature.new_badge')}
            </Badge>
          )}
        </Box>
      }
    >
      {group.features.map((feature, idx) => (
        <FeatureRow
          key={idx}
          products={products}
          feature={feature}
          isJapanesePackagePicker={isJapanesePackagePicker}
        />
      ))}
    </FeatureGroupComp>
  );
};

export default FeatureGroup;
